import apiCall from './apiRequest';
import endPoints from './endpoints';
import config from 'config';

export function fetchIntroEligibilityApi({ app }) {
  const { API } = config;
  const query = {};
  if (app) {
    query.app = app;
  }

  return apiCall({
    method: 'get',
    url: `${API.fastApi}/${endPoints.me.introEligibility}`,
    query
  });
}

export default {
  fetchIntroEligibilityApi
};



// WEBPACK FOOTER //
// ./src/api/offers.js